import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

const normalizeCnpj = (cnpj: string) => cnpj?.replace(/\D/g, '') || '';

export function useMapaParqueByCnpj(cnpj: string | null | undefined) {
  const cnpjLimpo = normalizeCnpj(cnpj || '');
  const enabled = cnpjLimpo.length === 14;

  const query = useQuery({
    queryKey: ['mapa-parque', cnpjLimpo],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('staging_mapa_parque')
        .select('nm_contato_sfa, celular_contato_principal_sfa, email_contato_principal_sfa, papel_contato_sfa, vl_car_fixa, vl_car_movel, m_mapa, m_consulta, qt_basica_linas, qt_basica_term_metalico, qt_basica_term_fibra, qt_bl_fttc, qt_bl_ftth, data_consulta, valor_consulta, linhas_moveis_consulta, vertical, tp_produto, tlfn_1, tlfn_2, tlfn_3, tlfn_4, tlfn_5, tel_comercial_siebel, tel_celular_siebel, tel_residencial_siebel, email_siebel, cluster, posse, primeira_oferta, segunda_oferta, terceira_oferta, recomendacao, trilha, cobertura_5g, msg_email_claro, qt_movel_term, qt_movel_pen, qt_movel_m2m, qt_movel_fwt, qt_basica_bl, qt_avancada_dados, avancada_voz, qt_vvn, qt_vivo_tech, qt_office_365, qtd_sfa_filiais, aparelhos, flg_mei, ds_cnae, ds_atividade_economica, situacao_receita, ds_endereco, ds_cidade, nr_cep, numero')
        .eq('nr_cnpj', cnpjLimpo)
        .order('dt_carga', { ascending: false, nullsFirst: false })
        .limit(1)
        .maybeSingle();
      if (error) {
        console.error('[useMapaParqueByCnpj] Erro:', error);
        return null;
      }
      return data;
    },
    enabled,
    staleTime: 5 * 60 * 1000,
    gcTime: 15 * 60 * 1000,
  });

  return { mapaParque: query.data, isLoading: query.isLoading };
}

/** O gestor da conta Vivo pela régua do banco (v_gestor_vivo_cnpj): e-mail de fachada fora, celular com 55 aceito. */
export function useGestorVivoCnpj(cnpj: string | null | undefined) {
  const cnpjLimpo = normalizeCnpj(cnpj || '');
  return useQuery({
    queryKey: ['gestor-vivo', cnpjLimpo],
    enabled: cnpjLimpo.length === 14,
    staleTime: 5 * 60 * 1000,
    queryFn: async () => {
      const { data, error } = await supabase
        .from('v_gestor_vivo_cnpj')
        .select('gestor_nome, gestor_papel, gestor_celular, gestor_email, email_siebel, celular_siebel, dt_carga')
        .eq('cnpj_digits', cnpjLimpo)
        .maybeSingle();
      if (error) throw error;
      return data;
    },
  });
}
